export default __webpack_public_path__ + "static/media/support-avatar.70554516.svg";